const deliverySaverShortNameFilter = require('./delivery-saver-short-name.filter');

module.exports = function () {
    return function (deliverySaverPlan = {}) {
        const shortName = deliverySaverShortNameFilter()(deliverySaverPlan);
        if (deliverySaverPlan.IsAnyDay) {
            return `Anyday, ${shortName}`;
        } else if (deliverySaverPlan.IsMidweek) {
            return `Midweek, ${shortName}`;
        }
        return shortName;
    };
};



// WEBPACK FOOTER //
// ./src/deliverysaver/delivery-saver-full-type-name.filter.js